export enum KnowEdmTableData {
  Md = 'md',
  Inclination = 'inclination',
  Azimuth = 'azimuth',
  Tvd = 'tvd',
  DepthTVD = 'depthTVD',
  DepthMD = 'depthMD',
  DrillfloorHeight = 'drillfloorHeight',
  GroundElevation = 'groundElevation',
  ExtrapolateToBit = 'extrapolateToBit',
  Dogleg = 'dogleg',
  LocalPositionEW = 'localPositionEW',
  LocalPositionNS = 'localPositionNS',
  Easting = 'easting',
  Northing = 'northing',
  OffsetEast = 'offset_east',
  OffsetNorth = 'offset_north',
  Vsec = 'v.sec',
  Build = 'build',
  BuildRate = 'build_rate',
  DoglegSeverity = 'dogleg_severity',
  TurnRate = 'turn_rate',
  ToolFaceAngle = 'tool_face_angle',
  SurveyName = 'survey_name',
  SurveyToolId = 'survey_tool_id', // will be changed once we connect error models?
  MdMin = 'md_min',
  MdMax = 'md_max',
  termName = 'term_name',
  vectorType = 'vector_type',
  tieType = 'tieType',
  tieOnRun = 'tieOnRun',
  cUnits = 'c_units',
  cValue = 'c_value',
  cFormula = 'c_formula',
  SurveyRun = 'surveyRun',
  DepthTo = 'depthTo',
  DepthFrom = 'depthFrom',
  SurveyDate = 'surveyDate',
  SurveyStatus = 'surveyStatus',
  WellboreID = 'wellboreID',
  SurveyRunParentID = 'surveyRunParentID',
  ReferenceDepth = 'referenceDepth',
  StartDepth = 'startDepth',
  StartDepthReference = 'startDepthReference',
  SurveyRunID = 'surveyRunID',
  SurveyRunName = 'surveyRunName',
  SurveyRunAssociatedDataId = 'surveyRunAssociatedDataId',
  SurveyProgram = 'surveyProgram',
  TieOn = 'tieOn',
  ToolFace = 'toolface',
  ToolModel = 'toolModel',
  Tool = 'tool',
  ToolID = 'toolID',
  Turn = 'turn',
  Name = 'name',
  Header = 'header',
  ToolName = 'toolName',
  Unit = 'unit',
  Value = 'value',
  Formula = 'formula',
  Vector = 'vector',
  VerticalSection = 'verticalSection',
  Cl = 'Cl',
  Ew = 'Ew',
  Ns = 'Ns',
  Dls = 'Dls',
  Tf = 'Tf',
  Tfo = 'Tfo',
  IPMFile = 'ipmFile',
  GeomagneticParametersDefinition = 'geomagneticParametersDefinition',
  IncOnly = 'inconly',
  HoleSize = 'holeSize',
  CovarianceMatrix = 'covarianceMatrix',
}

export enum KnowTableData {
  DepthMd = 'depthMd',
  DepthTvd = 'depthTvd',
  Inclination = 'inclination',
  Azimuth = 'azimuth',
  LocalPositionEW = 'localPositionEW',
  LocalPositionNS = 'localPositionNS',
  Dogleg = 'dogleg',
  BuildMethod = 'buildMethod',
  CurveLength = 'curveLength',
  VerticalSection = 'verticalSection',
  Turn = 'turn',
  Toolface = 'toolface',
  Build = 'build',
  InclinationMin = 'inclinationMin',
  InclinationMax = 'inclinationMax',
}
